/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GeoItemAreaInput = {
  featureCollection?: Types.JsonObject | null | undefined;
  geometry?: Types.JsonObject | null | undefined;
  h3Indexes?: Array<string> | null | undefined;
  kind: GeoItemAreaKind;
};

export type GeoItemAreaKind =
  | 'feature_collection'
  | 'geometry'
  | 'h3';

export type GeoItemLabelInput = {
  lang: string;
  preferred?: boolean | null | undefined;
  value: string;
};

export type GeoItemWithoutRecordCreateInput = {
  areaInput: GeoItemAreaInput;
  fromJdn?: number | null | undefined;
  labels?: Array<GeoItemLabelInput> | null | undefined;
  metadata?: Types.JsonObject | null | undefined;
  parentKey?: string | null | undefined;
  tenantId: string;
  toJdn?: number | null | undefined;
};

export type CreateStandaloneGeoItemMutationVariables = Exact<{
  input: Types.GeoItemWithoutRecordCreateInput;
}>;


export type CreateStandaloneGeoItemMutation = { cnutCreateGeoItemWithoutRecord: { __typename: 'GeoItemOutput', id: string } };


export const CreateStandaloneGeoItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateStandaloneGeoItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GeoItemWithoutRecordCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutCreateGeoItemWithoutRecord"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateStandaloneGeoItemMutation, CreateStandaloneGeoItemMutationVariables>;